module.exports = __webpack_public_path__ + "img/ic_gift.c5f46198.png";